import api from '@/api';
import { TGetListRequest } from '@/api/sendList';
import { addNotificationDanger } from '@/store/slices/notificationsSlice';
import { TSendListItem } from '@/types/sendList';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getSendList = createAsyncThunk<TSendListItem[], TGetListRequest | undefined>(
    'sendList/getSendList',
    async (req, thunkAPI) => {
        try {
            return await api.sendList.getList(req);
        } catch (e) {
            thunkAPI.dispatch(addNotificationDanger({ text: e as string }));
            return [];
        }
    },
);
